import React, { ChangeEvent, FC, PropsWithChildren, useState } from 'react';
import { clsx } from 'clsx';

import styles from './TextAreaInput.module.scss';

export interface ITextAreaInputWrapperProps {
    active: boolean;
}

export const TextAreaInputWrapper = ({ children, active }: PropsWithChildren<ITextAreaInputWrapperProps>) => (
    <div className={clsx(styles.textAreaInputWrapper, active && styles.textAreaInputActiveClass)}>
        {children}
    </div>
);

interface ITextAreaInputLabelProps extends ITextAreaInputWrapperProps {
    placeholder?: string;
}

export const TextAreaInputLabel: FC<ITextAreaInputLabelProps> = ({ placeholder, active }) => (
    <label className={clsx(styles.textAreaInputLabel, active && styles.textAreaInputLabelActive)}>
        {placeholder}
    </label>
);

interface ITextAreaInputCounterProps {
    charactersCounter: number;
}

export const TextAreaInputCounter: FC<ITextAreaInputCounterProps> = ({ charactersCounter }) => (
    <span className={styles.charactersCounterClass}>
        {charactersCounter}
    </span>
);

export interface ITextAreaProps extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>{}

export const TextArea = ({ value, onChange, onFocus, onBlur, maxLength }: ITextAreaProps) => {

    return (
        <textarea
            className={clsx(styles.textAreaInput)}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            maxLength={maxLength}
        />
    );
};

export interface ITextAreaInputProps extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>{
    wrapperClass?: string;
}

export const TextAreaInput = ({ wrapperClass, value, onChange, placeholder, maxLength }: ITextAreaInputProps) => {

    const [activeClass, setActiveClass] = useState(false);

    const handleTextAreaInputValue = (event: ChangeEvent<HTMLTextAreaElement>) => {
        if (!activeClass) {
            setActiveClass(true);
        }

        if (onChange) {
            onChange(event);
        }
    };

    const handleTextAreaInputFocus = () => {
        if (!activeClass) {
            setActiveClass(true);
        }
    };

    const handleTextAreaInputBlur = () => {
        setActiveClass(false);
    };

    let charactersCounter = 0;

    if (maxLength) {
        charactersCounter = typeof value === 'string' ? maxLength - value.length : 0;
    }

    return (
        <div className={wrapperClass}>
            <TextAreaInputWrapper active={activeClass}>
                {placeholder && <TextAreaInputLabel placeholder={placeholder} active={activeClass || !!value} />}
                <TextArea
                    value={value}
                    onFocus={handleTextAreaInputFocus}
                    onChange={handleTextAreaInputValue}
                    onBlur={handleTextAreaInputBlur}
                    maxLength={maxLength}
                />
            </TextAreaInputWrapper>
            {maxLength && <TextAreaInputCounter charactersCounter={charactersCounter} />}
        </div>
    );
};
